module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      免费云服务器管理\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "main-area"
  }, [(_vm.num == 1) ? _c('div', [_c('div', {
    staticClass: "operate-panel"
  }, [_c('div', {
    staticClass: "operate-main-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "server-name"
  }, [_c('span', {
    staticStyle: {
      "max-width": "9rem"
    }
  }, [_vm._v(_vm._s(_vm.vpsInfo.vps_name))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_vm._v(_vm._s(_vm.vpsInfo.ip))])]), _vm._v(" "), _c('ul', {
    staticClass: "btn-box"
  }, [_c('li', [_c('a', {
    staticClass: "renew-btn handle-btn",
    on: {
      "click": _vm.Delay
    }
  }, [_vm._v("免费延期")]), _vm._v(" "), _c('span', {
    staticClass: "op-btn-cover"
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "restart-btn handle-btn",
    on: {
      "click": _vm.Restart
    }
  }, [_vm._v("重启")]), _vm._v(" "), _c('span', {
    staticClass: "op-btn-cover"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "more-btn",
    on: {
      "click": function($event) {
        _vm.hide = !_vm.hide
      }
    }
  }, [_c('div', [_vm._v("\n                      更多\n                    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "links-container"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Reinstallserver
    }
  }, [_c('i', {
    staticClass: "operate-reinstall"
  }), _vm._v(" 重装系统\n                        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.ResetPassword
    }
  }, [_c('i', {
    staticClass: "operate-repwd"
  }), _vm._v(" 重设密码\n                        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.ChooseStop
    }
  }, [_c('i', {
    staticClass: "operate-stop"
  }), _vm._v(" 关机\n                        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Record
    }
  }, [_c('i', {
    staticClass: "operate-record"
  }), _vm._v(" 延期记录\n                        ")])])])])])])])]), _vm._v(" "), _c('tab', {
    staticStyle: {
      "margin": "0 0.1rem"
    },
    attrs: {
      "animate": false
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.tab = 'first'
      }
    }
  }, [_vm._v("实例详情")]), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": _vm.Monitor
    }
  }, [_vm._v("性能监控")])], 1), _vm._v(" "), (_vm.tab === 'first') ? _c('div', [_c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("名称")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.vps_name) + "\n                    ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("备注")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.vps_remark) + "\n                    ")])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("网络类型")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.NET_TYPE) + "\n                    ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("公网IP")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.ip) + "\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("操作系统")]), _vm._v("\n                  " + _vm._s(_vm.vpsInfo.OsType) + "\n                ")]), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("状态")]), _vm._v("\n                      " + _vm._s(_vm.state) + "\n                    ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("到期时间")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.EndTime) + "\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("CPU")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.CPU) + "核\n                    ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("公网带宽")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.NET_WIDTH) + "G\n                    ")])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("内存")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.RAM) + "G\n                    ")])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("SSD数据盘")]), _vm._v("\n                      " + _vm._s(_vm.vpsInfo.SSD) + "G\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [(_vm.ImgListLoading) ? _c('load-more', {
    staticStyle: {
      "position": "absolute",
      "left": "16%",
      "top": "46%",
      "color": "#fff"
    },
    attrs: {
      "tip": "图片加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.ImgUrl,
      "alt": ""
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'second') ? _c('div', [_c('div', {
    staticClass: "server-monitor-container"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_c('li', {
    staticClass: "detail-list-tit"
  }, [_c('div', [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t磁盘使用率"), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(单位：" + _vm._s(_vm.netunit) + ")")])])])]), _vm._v(" "), _vm._m(6)])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.num == 0) ? _c('div', [_c('x-button', {
    staticStyle: {
      "width": "100px",
      "margin-top": "100px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.vpsInit($event)
      }
    }
  }, [_vm._v("立即开通")])], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('popup', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "popup0"
  }, [_c('group', [_c('p', {
    staticStyle: {
      "line-height": ".8rem",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.Stop('close')
      }
    }
  }, [_vm._v("正常关机")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": ".8rem",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.Stop('shutdown')
      }
    }
  }, [_vm._v("强制关机")])])], 1)])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-box"
  }, [_c('div', {
    staticClass: "status-circle state-border-success"
  }, [_c('div', {
    staticClass: "product-head-icon server-manage-icon"
  }, [_c('span', {
    staticClass: "text-success",
    attrs: {
      "id": "serverStatus",
      "data-status": "1",
      "data-encode_id": "",
      "data-need_refresh_status": "true"
    }
  }, [_vm._v("运行中")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("配置信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("当前截图")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "detail-box"
  }, [_c('li', {
    staticClass: "detail-list-tit"
  }, [_c('div', [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCPU利用率"), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(单位：%)")])])])]), _vm._v(" "), _c('li', {
    staticClass: "box-content chart-box"
  }, [_c('div', {
    staticClass: "charts-container",
    attrs: {
      "id": "cpuChart"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "detail-box"
  }, [_c('li', {
    staticClass: "detail-list-tit"
  }, [_c('div', [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t磁盘使用率"), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(单位：%)")])])])]), _vm._v(" "), _c('li', {
    staticClass: "box-content chart-box"
  }, [_c('div', {
    staticClass: "charts-container",
    attrs: {
      "id": "iops"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "box-content chart-box"
  }, [_c('div', {
    staticClass: "charts-container",
    attrs: {
      "id": "netMinu"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a4e8fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/freeserver.vue
// module id = MpjB
// module chunks = 1